import styled from "styled-components";

export const StepWrapper = styled.div`
  margin-bottom: var(--outerMargin);
  border: var(--border);
`;

export const StepheaderDiv = styled.div`
  padding: var(--gap);
  border-bottom: var(--border);
  & h2 {
    margin: 0;
    display: flex;
    justify-content: space-between;
  }
  & h3 {
    margin: 0;
  }
`;

export const StepBodyDiv = styled.div`
  display: flex;
  & > div {
    flex: 1;
    padding: var(--gap);
    & + div {
      margin-left: var(--gap);
      padding-left: var(--gap);
      border-left: var(--border);
      & > p:first-child {
        margin-top: 0;
      }
    }
  }
`;

export const StepComment = styled.div`
  padding: var(--gap);
`;

export const WalkHeader = styled.div`
  padding: var(--gap) 0;
`;
